module.exports = __webpack_public_path__ + "static/media/Settings.ea33e5db.svg";